import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import PewForecast from 'components/Apps/EnvironmentMonitor/PewForecast'
import PewListWrapper from 'components/Apps/EnvironmentMonitor/PewListView'
import PewList from 'components/Apps/EnvironmentMonitor/PewList/PewList'
import { fetchPewForecastList } from 'reducers/environmentMonitor/reducer'
import { getPewStatus } from 'helpers/environmentMonitor'
import NoData from 'components/common/NoData/NoData'

class Pew extends Component {
  constructor(props) {
    super(props)
    this.state = {
      forecastItem: 0,
    }
  }

  componentDidMount() {
    this.fetchChartData(this.props.activeSite)
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.activeSite !== nextProps.activeSite) {
      this.fetchChartData(nextProps.activeSite)

      return false
    }

    return true
  }

  fetchChartData = activeSite => {
    const { fetchPewForecastList } = this.props
    fetchPewForecastList({
      site: activeSite,
      now: moment.utc().format('YYYY-MM-DD HH:00:00'),
    })
  }

  onHover = listItem => this.setState({ forecastItem: listItem })

  render() {
    const { licenseeName } = this.props
    const data = this.props.pewForecastList.toJS()[this.state.forecastItem]

    if (data === undefined) {
      return <NoData />
    }

    return (
      <>
        <PewForecast>
          <PewList
            statusCode={getPewStatus}
            onHover={this.onHover}
            forecastData={this.props.pewForecastList}
          />
        </PewForecast>
        <PewListWrapper
          listItem={data}
          statusCode={getPewStatus}
          licenseeName={licenseeName}
        />
      </>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    pewForecastList: state.getIn(['environmentMonitor', 'pewForecastList']),
    licenseeName: state.getIn(['profile', 'licenseeName']),
  }),
  {
    fetchPewForecastList,
  },
)(Pew)
